<script setup>
import BaseBadge from '@/components/Base/BaseBadge.vue';
import BaseIcon from '@/components/Base/BaseIcon.vue';
import BaseTooltip from '@/components/Base/BaseTooltip.vue';

defineProps({
  items: {
    type: Array,
    default() {
      return [];
    },
  },
  secondaryItems: {
    type: Array,
    default() {
      return [];
    },
  },
  title: {
    type: String,
    default: 'Secondary Skills',
  },
  noPadding: {
    type: Boolean,
    default: false,
  },
  badgeClass: {
    type: Object,
    default() {
      return {};
    },
  },
});
</script>
<template>
  <div class="flex gap-[8px]">
    <BaseBadge
      v-for="(item, index) in items"
      :key="index"
      class="cursor-default"
      :class="{ '!mx-0': noPadding, ...badgeClass }"
    >
      <span class="truncate">{{ item.title ?? item }}</span>
      <BaseTooltip
        v-if="item.subtitle"
        :offset="[0, 6]"
      >
        {{ item.subtitle }}
      </BaseTooltip>
    </BaseBadge>
    <BaseBadge
      v-if="secondaryItems.length"
      class="cursor-default"
      :class="{ '!mr-0': noPadding, ...badgeClass }"
    >
      <template #append>
        <BaseIcon
          name="plus"
          class="-mx-1.5"
        />
        <span>{{ secondaryItems.length }}</span>
        <BaseTooltip :offset="[0, 6]">
          <div
            v-if="title"
            class="font-semibold my-1"
          >
            {{ title }} ({{ secondaryItems.length }})
          </div>
          <div class="flex flex-col gap-[8px]">
            <BaseBadge
              v-for="(item, index) in secondaryItems"
              :key="index"
              :label="
                item.title && item.subtitle
                  ? `${item.title} (${item.subtitle})`
                  : item
              "
              class="!font-normal"
            />
          </div>
        </BaseTooltip>
      </template>
    </BaseBadge>
  </div>
</template>
